import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Card from '../card'
// import SvgIconInfoBlue from '../../../assets/icon-info-blue.svg'
import { PrimaryButton } from '../button/button.styled'
import TextArea from '../textarea'
// import Error from '../error'
import Checkbox from '../Checkbox'
import useSubmitEvisit from '../../../hooks/useSubmitEvisit'

const StyledFeedStatusAction = styled.div`
  > div:first-child {
    display: flex;
    img {
      margin-right: 18px;
    }
    p {
      font-weight: 700;
      font-size: 14px;
    }
  }

  > div.buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  textarea {
    width: calc(100% - 78px);
    margin-top: 6px;
    margin-left: 38px;
  }
`

interface IFeedStatusProps {
  createdAt: string
}

const FeedAddEVisit: React.FC<IFeedStatusProps> = (props) => {
  const { createdAt } = props
  const { t } = useTranslation()
  const [note, setNote] = useState('')
  const [eIsChecked, setEIsChecked] = useState(false)
  // const [isError, setIsError] = useState(false)

  const eVisit = useSubmitEvisit()

  const handleAcceptedPatient = (e: React.MouseEvent) => {
    e.preventDefault()
    eVisit.mutate({
      hasEtermin: true,
      note,
    })
    setNote('')
  }

  /*  const handleRejectedPatient = (e: React.MouseEvent) => {
    e.preventDefault()

    if (!note) {
      setIsError(true)
      return
    }

    approve.mutate({
      approve: false,
      note,
    })

    setNote('')
  } */

  return (
    <Card date={createdAt}>
      <StyledFeedStatusAction>
        <div>
          <p>{t('feedAddEVisit.title')}</p>
        </div>
        <Checkbox
          style={{ marginBottom: 16 }}
          checked={eIsChecked}
          label={t('feedAddEVisit.confirmCheckboxLabel')}
          onChangeHandler={(ch) => setEIsChecked(ch)}
        />
        <TextArea
          placeholder={t('general.addNote')}
          labelId=''
          onChangeHandler={(e) => setNote(e)}
          value={note}
        />
        {/*  {isError && <Error>{t('newRequest.patientRejected')}</Error>} */}

        <div className='buttons'>
          <PrimaryButton
            type='button'
            onClick={handleAcceptedPatient}
            disabled={eIsChecked ? false : true}
          >
            {t('general.save')}
          </PrimaryButton>
        </div>
      </StyledFeedStatusAction>
    </Card>
  )
}

export default FeedAddEVisit
